<template> 
  <modal :value="value"
          max-width="750"
          content-class="sms-modal"
          :has-padding="false"
          @input="emitInput">
    <div class="sms-modal-body">
      <h1 class="sms-modal-body-title">{{$t('message.marketingGenerics.message.creditHistory')}}</h1>

      <div class="sms-modal-body-infos">
        <div class="sms-modal-body-infos-total">
          <div class="sms-modal-body-infos-total-title">{{$t('message.creditManagement.message.totalAvailable')}}</div>
          <div class="sms-modal-body-infos-total-amount">{{ totalText }}</div>
        </div>
      </div>

      <marketing-credits-list v-if="value"
                              :channel-type="channelType" />
    </div>
  </modal>    
</template>

<script>
import MarketingCreditsList from "@components/modules/marketing/generic/credits/list/MarketingCreditsList";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    MarketingCreditsList,
    Modal
  },
  data() {
    return {
      total: 0,
      loading: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    channelType: {
      type: String,
      default: "SMS"
    },
  },

  created() {},

  computed: {
    totalText() {
      return this.channelType === "SMS"
        ? `${this.total} ${this.$t('message.generics.message.sms')} `
        : this.channelType === "WHATSAPP"
          ? `${this.total} WhatsApp `
          : `${this.total} ${this.total === 1 ? this.$t('message.generics.message.email') : this.$t('message.email.message.emails')}`;
    },
    user() {
      return this.$store.state.users.user;
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.loadTotal();
      }
    },
  },

  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },
    hideModal() {
      this.emitInput(false);
    },
    async loadTotal() {
      try {
        this.loading = true;

        const total = await this.$api.marketing.account.credit.total({
          accountId: this.user.accountId,
          type: this.channelType,
        });

        this.total = total;
      } catch (error) {
        //empty
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-modal {
  .sms-modal-body {
    padding: 10px 20px;
    overflow-y: scroll;

    .sms-modal-body-title {
      text-align: center;
      font-size: 32px;
      font-weight: 600;
    }

    .sms-modal-body-infos {
      margin-bottom: 30px;

      .sms-modal-body-infos-total {
        width: fit-content;
        border: 1px solid #cecfd0;
        padding: 20px;
        text-align: center;
        border-radius: 20px;

        .sms-modal-body-infos-total-title {
          font-weight: 500;
          color: #43425d;
          margin-bottom: 5px;
          font-size: 14px;
        }

        .sms-modal-body-infos-total-amount {
          color: #4d4f5c;
          font-weight: 600;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
